module.exports = __webpack_public_path__ + "static/media/card-front.89597e1d.png";